import React, { useState } from "react"
import { useWindowSize } from "../hooks"
import { IconExpand } from "../images"
import Modal from "./Modal"

interface VideoProps {
  videoSrcURL: string
  videoTitle: string
}

export default function Video(props: VideoProps) {
  const { videoSrcURL, videoTitle } = props

  const [isModalOpen, setIsModalOpen] = useState(false)

  const window = useWindowSize()
  const isLaptop = window.width && window.width > 1024

  return (
    <div className="relative group">
      <Iframe videoSrcURL={videoSrcURL} videoTitle={videoTitle} />
      {isLaptop && (
        <button
          className="p-0.5 rounded-8 focus:outline-none absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 ease-in-out"
          style={{ backgroundColor: `rgba(0,0,0,0.4)` }}
          onClick={() => setIsModalOpen(true)}
        >
          <IconExpand className="w-4 h-4 text-white" />
        </button>
      )}
      <Modal isOpen={isModalOpen} onRequestClose={() => setIsModalOpen(false)}>
        <Iframe videoSrcURL={videoSrcURL} videoTitle={videoTitle} />
      </Modal>
    </div>
  )
}

function Iframe(props: VideoProps) {
  const { videoSrcURL, videoTitle } = props
  return (
    <div className="w-full overflow-hidden relative group" style={{ paddingTop: "56.25%" }}>
      <iframe
        src={videoSrcURL}
        title={videoTitle}
        className="w-full h-full absolute inset-0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        frameBorder="0"
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        allowFullScreen
      />
    </div>
  )
}
